// Copyright 2019-2022 @polkadot/wasm-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Bridge } from '@polkadot/wasm-bridge';
import { createWasm } from '@polkadot/wasm-crypto-init';
export const bridge = new Bridge(createWasm);
export async function initBridge(createWasm) {
  return bridge.init(createWasm);
}